(() => {
  const sliders = document.querySelectorAll('[data-deal-slider]');

  sliders.forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-deal-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-deal-dot]'));
    const previous = slider.querySelector('[data-deal-previous]');
    const next = slider.querySelector('[data-deal-next]');
    const status = slider.querySelector('[data-deal-status]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = null;

    if (slides.length < 2) return;

    const show = (index, announce = false) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.tabIndex = active ? 0 : -1;
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      slider.style.setProperty('--amm-slide-index', current);
      slider.classList.remove('is-counting');
      void slider.offsetWidth;
      slider.classList.add('is-counting');
      if (announce && status) status.textContent = `Showing ${slides[current].dataset.label}`;
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
      slider.classList.remove('is-counting');
    };

    const start = () => {
      stop();
      if (!reduceMotion) {
        slider.classList.add('is-counting');
        timer = window.setInterval(() => show(current + 1), 6500);
      }
    };

    previous?.addEventListener('click', () => { show(current - 1, true); start(); });
    next?.addEventListener('click', () => { show(current + 1, true); start(); });
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index, true); start(); }));

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', (event) => {
      if (!slider.contains(event.relatedTarget)) start();
    });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

    show(current);
    start();
  });
})();
